<template>
    <div class="map--search--option">
        <button type="button" @click="closeModal()" class="modalCloseBtn"><i></i></button>
        <ul class="depth--top">
          <li v-for="(menu, index) in menuList" v-bind:key="index" :class="{'on': selectedTopMenuId === menu.mapSysNo}" :style="topMenuWidth">
            <button type="button" @click.prevent="clickStatTopMenu( menu.mapSysNo, menu.mapSysNm, $event)">{{menu.mapSysNm }}</button>
          </li>
        </ul>
        <h2>통계분류</h2>
        <div class="depth--middle" v-for="(menu, index) in menuList" v-bind:key="index" :class="{'on': selectedTopMenuId === menu.mapSysNo}" style="height:256px;overflow:auto;">
          <ul class="depth--middle--inner"  v-for="(subMenu, subIndex) in menu.children" v-bind:key="subIndex">
            <li>
              <button type="button" @click.prevent="clickStatGroupMenu(subMenu.mapSysNo, $event)" >{{subMenu.mapSysNm}}</button>
              <ul class="depth--bottom" :class="{'on': selectedSubMenuId === subMenu.mapSysNo}">
                <li v-for="(statMenu, statMenuIndex) in subMenu.children" :key="statMenuIndex" :class="{'on' : selectedStatMenuId === statMenu.mapSysNo}">
                  <button type="button" @click="clickStatItemMenu( statMenu.mapSysNo, statMenu.mapSysNm, statMenu.srcCd, statMenu.srcNo )">{{statMenu.mapSysNm}}</button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div style="height: 50px;"></div>

        <div class="modal--mask" style="display: none;"></div>
      </div>
</template>
<script>
import ListModal from './ListModal.vue'
import YearModal from './YearModal.vue'
import commonUI from '@/mixin/commonUI'
import menuApi from '@/api/web/MenuApi'
import FullPageModal from 'vue-fullpage-modal'
import { eventBus } from '@/event-bus'
import { mapActions, mapGetters, mapState } from 'vuex'

const statItemStore = 'statItemStore'

export default {
  name:"ModalView",
  mixins: [commonUI],
  data() {
    return {
      menuList: [],
      searchStatItemList: [],
      searchStatItemYearList: [],
      selectedTopMenuId: '',
      selectedSubMenuId: '',
      selectedStatMenuId: '',
      selectedStatMenuName: '',
      selectedStatSrcCd: '',
      selectedStatSrcNo: '',
      isShowStatMenuLocation: true,
      isShowMenu: true
    }
  },
  components: {
    listModal: FullPageModal
  },
  computed: {
    ...mapGetters(statItemStore, {
      statItemMaxCount: 'statItemMaxCount',
      findStatItem: 'findStatItem',
      findStatMenu: 'findStatMenu',
      statItemCount: 'statItemCount',
      selectedStatItems: 'selectedStatItems',
    }),
    ...mapState(statItemStore, {
      statItems: state => state.statItems
    }),

    topMenuWidth() {
      return {
        'width': (100 / this.menuList.length) + '%'
      }
    }
  },
  created() {
    this.initEventBus()
    this.searchMenu()
  },
  beforeDestroy () {
    eventBus.$off('selectStatItem')
    eventBus.$off('selectStatYearItem')
    eventBus.$off('listNextEvent')
    eventBus.$off('yearCompleteEvent')
  },
  methods: {
    ...mapActions(statItemStore, {
      addStatItem: 'addStatItem',
      removeStatItem: 'removeStatItem',
      removeAllStatItem: 'removeAllStatItem',
      setStatItemYearList: 'setStatItemYearList'
    }),

    initEventBus() {
      // 항목선택 이벤트
      eventBus.$on('selectStatItem', (statItem) => {
        const findStatItem = this.findStatItem(statItem.mapItmNo)
        if (findStatItem) {
          this.removeStatItem({ info: statItem })
        } else {
          if (this.statItemCount <= this.statItemMaxCount) {
            this.addStatItem({
              mapSysNo: this.selectedStatMenuId,
              mapSysNm: this.selectedStatMenuName,
              srcCd: this.selectedStatSrcCd,
              srcNo: this.selectedStatSrcNo,
              info: statItem,
              years: []
            })
          }
        }
        this.searchStatItemYear(this.selectedStatMenuId)
      })

      // 연도선택 이벤트
      eventBus.$on('selectStatYearItem', (statYearItem) => {
        let findStatItem = this.findStatMenu(this.selectedStatMenuId)
        if (findStatItem){
          if (findStatItem.years) {
            if (findStatItem.years.indexOf(statYearItem.year) == -1 ) {
              findStatItem.years.push(statYearItem.year)
            } else {
              findStatItem.years.splice(findStatItem.years.indexOf(statYearItem.year), 1)
            }

            this.setStatItemYearList({
              mapSysNo: this.selectedStatMenuId,
              yearList: findStatItem.years
            })
          }
        }
      })

      // 항목선택 다음버튼 이벤트
      eventBus.$on('listNextEvent', (selectedStatMenuList) => {
        if (selectedStatMenuList.length > 0) {
            this.showYearOpenModal()
        }
      })

      // 연도선택 완료버튼 이벤트
      eventBus.$on('yearCompleteEvent', (selectedYearMenuList) => {
        if (selectedYearMenuList.length > 0) {
            this.closeModal()
        }
      })
    },

    // 메뉴조회
    async searchMenu() {
      const searchMenuData = await menuApi.searchMenu()
      for (const menuData of searchMenuData) {
        if (menuData.children.length > 0) {
          this.menuList.push(menuData)
        }
      }

      // this.menuList = searchMenuData

      if (this.menuList.length > 0) {
        this.selectedTopMenuId = this.menuList[0].mapSysNo
      }
    },

    // 통계분류에 해당하는 항목 조회 후
    async searchStatItem (mapSysNo) {
      const searchStatItemData = await menuApi.searchStatItemList(mapSysNo)
      this.searchStatItemList = searchStatItemData

      this.showStatItemListModal()
    },

    // 통계분류 항목에 해당 연도 목록 조회
    async searchStatItemYear (mapSysNo) {
      const searchStatItemYearData = await menuApi.searchStatItemYear(mapSysNo)
      this.searchStatItemYearList = searchStatItemYearData
    },

    // 최상위 메뉴 이벤트
    clickStatTopMenu (mapSysNo, menuName, event){
      this.selectedTopMenuId = mapSysNo
    },

    // 통계분류 목록 메뉴 이벤트
    clickStatGroupMenu (mapSysNo, event){
      const siblings = t => [...t.parentElement.children].filter(e => e != t);
      const target = event.target;
      const subMenuListClose = siblings(target.parentNode.parentNode)
      this.selectedSubMenuId = mapSysNo
      subMenuListClose.forEach((itm, idx) =>{
        this.slideUp(itm.querySelector('.depth--bottom'))
      })
      if(this.selectedSubMenuId){
        this.slideToggle(target.nextSibling, 500);
      }
    },

    // 통계분류 선택
    clickStatItemMenu (mapSysNo, menuName, srcCd, srcNo){
      // 선택된 통계분류와 새로 선택된 통계분류 ID 다를경우 현재 선택된 통계 아이템은 초기화 한다.
      if (this.selectedStatMenuId !== mapSysNo) {
        this.removeAllSelectedStatItem()
      }

      this.selectedStatMenuId = mapSysNo
      this.selectedStatMenuName = menuName

      if (!srcNo) {
        this.selectedStatSrcCd = ''
        this.selectedStatSrcNo = ''
      } else {
        this.selectedStatSrcCd = srcCd
        this.selectedStatSrcNo = srcNo
      }

      this.searchStatItem(mapSysNo)
      this.searchStatItemYear(this.selectedStatMenuId)
    },

    // 선택된 통계 아이템 정보 초기화
    removeAllSelectedStatItem () {
      this.removeAllStatItem()
    },

    // 선택된 통계 아이템 정보 삭제
    removeSelectedStatItem (removeStatItem) {
      for (let idx = 0; idx < this.selectedStatItems.length; idx++) {
        const statItem = this.selectedStatItems[idx].info
        if (statItem.mapItmNo === removeStatItem.mapItmNo) {
          const findItem = this.findStatItem(removeStatItem.mapItmNo)
          if (findItem) {
            this.removeStatItem({ info: removeStatItem })
          }
        }
      }
    },

    // 통계분류 통계항목 팝업 오픈
    showStatItemListModal () {
      let selectedItemList = []
      for (const statItem of this.selectedStatItems) {
        if (this.selectedStatMenuId === statItem.mapSysNo) {
          selectedItemList.push(statItem.info)
        }
      }
      this.$FModal.show(
        {
          component: ListModal,
          width: 'calc(100% - 20px)',
          maxHeight: '100%',
          placement: 'center center'
        },
        {
          mapSysNo: this.selectedStatMenuId,
          statItemList: this.searchStatItemList,
          selectedStatItemList: selectedItemList
        }
      )
    },

    // 통계분류 통계 연도 팝업 오픈
    showYearOpenModal () {
      let selectedYearList = []
      const findStatItem = this.findStatMenu(this.selectedStatMenuId)
      if (findStatItem) {
        selectedYearList = findStatItem.years
      }

      this.$FModal.show(
        {
          component: YearModal,
          width: 'calc(100% - 20px)',
          maxHeight: '100%',
          placement: 'center center'
        },
        {
          mapSysNo: this.selectedStatMenuId,
          statItemYearList: this.searchStatItemYearList,
          selectedStatItemYearList: selectedYearList
        }
      )
    },

    // 통계분류 슬라이드 다운 UI 설정
    slideDown (target, duration = 500) {
      target.style.removeProperty('display');
      let display = window.getComputedStyle(target).display;
      if (display === 'none')
        display = 'block';
      target.style.display = display;
      let height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = "height, margin, padding";
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    },

    // 통계분류 슬라이드 업 UI 설정
    slideUp (target, duration=500) {
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
      }, duration);
    },

    // 통계분류 슬라이드 Toggle 설정
    slideToggle (target, duration = 500) {
      if (window.getComputedStyle(target).display === 'none') {
        return this.slideDown(target, duration);
      } else {
        return this.slideUp(target, duration);
      }
    },

    // 현재 화면(통계분류 선택 팝업) 닫기
    closeModal () {
      this.$FModal.hide()
      setTimeout(() => {
        this.$FModal.destroyAll()
      }, 500)
    },
  }
}
</script>
<style scoped>
  .modalCloseBtn{
    position: absolute;
    top:20px;
    left:0;
    right:0;
    margin:0 auto;
    display: block;
    width:20%;
    height:5px;
    border-radius: 25px;
    background-color: #bbbbbb;
  }

</style>
